// Etapa 15 (S05 §Estados na UI) — único ponto que decide "isto conta como
// online?" a partir de um NetInfoState, reaproveitado tanto pelo indicador
// discreto do Perfil (estado atual, ver ProfileScreen) quanto pelo gatilho
// de sync automático em app/_layout.tsx (borda offline→online) — cada um
// assina o NetInfo à sua própria maneira (estado vs. evento de transição),
// mas os dois concordam sobre o que "online" significa.
//
// `import type` (não runtime) para não puxar @react-native-community/netinfo
// para o grafo de import de nenhum teste que só use este arquivo por tipo.
import type { NetInfoState } from '@react-native-community/netinfo';

/** `isInternetReachable` pode vir `null` em estados transitórios (a lib
 * ainda não confirmou) — nesse caso confia em `isConnected`, mesmo
 * comportamento recomendado pela doc do netinfo. */
export function isOnline(state: NetInfoState): boolean {
  return !!state.isConnected && state.isInternetReachable !== false;
}
